import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=6ae30f6a&scoped=true&"
import script from "./payment-methods.vue?vue&type=script&lang=js&"
export * from "./payment-methods.vue?vue&type=script&lang=js&"
import style0 from "./payment-methods.vue?vue&type=style&index=0&id=6ae30f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae30f6a",
  null
  
)

export default component.exports